module.exports = __webpack_public_path__ + "img/login_bg.4f9d71e2.png";